import React from "react";
import "./Footer.css";
import shape from "../../../assets/Home/shape-bg.png";
export default function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-parent">
        {/* Removed hardcoded width: 2600px — inline styles override CSS max-width,
            causing the layout to be wider than the viewport on large screens */}
        <img
          src={shape}
          alt=""
          role="presentation"
        />
      </div>
    </div>
  );
}
